function getBrowser() {
    const ua = navigator.userAgent

    if (ua && ua.indexOf('Chrome') > -1) {
        return {
            name: 'Chrome',
            version: parseFloat(ua.split('Chrome/')[1]?.split(' ')[0] || '0'),
        }
    }

    if (ua && ua.indexOf('Safari') > -1) {
        const versionIndex = ua.indexOf('Version/')
        return {
            name: 'Safari',
            version: versionIndex > -1 ? parseFloat(ua.split('Version/')[1]?.split(' ')[0] || '0') : 0,
        }
    }

    if (ua && ua.indexOf('Firefox') > -1) {
        return {
            name: 'Firefox',
            version: parseFloat(ua.split('Firefox/')[1]?.split(' ')[0] || '0'),
        }
    }

    if (ua && ua.indexOf('MSIE') > -1) {
        return {
            name: 'IE',
            version: parseFloat(ua.split('MSIE ')[1]?.split(' ')[0] || '0'),
        }
    }

    if (ua && ua.indexOf('Trident') > -1) {
        return {
            name: 'IE',
            version: parseFloat(ua.split('rv:')[1]?.split(')')[0] || '0'),
        }
    }

    if (ua && ua.indexOf('Edge') > -1) {
        return {
            name: 'Edge',
            version: parseFloat(ua.split('Edge/')[1]?.split(' ')[0] || '0'),
        }
    }

    if (ua && ua.indexOf('Opera') > -1) {
        return {
            name: 'Opera',
            version: parseFloat(ua.split('Version/')[1]?.split(' ')[0] || '0'),
        }
    }

    return {
        name: 'Unknown',
        version: 0,
    }
}

export default getBrowser
